var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center h-32"},[_c('div',{staticClass:"animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-red-500"})])
}]

export { render, staticRenderFns }